import { clsx } from 'clsx'
import { useLatestCallback } from 'hook/useLatestCallback'
import { MouseEvent, ReactNode } from 'react'

import { getPaddingStyle, Padding, styles } from 'util/style'
import css from './Link.module.scss'

interface Props {
  action?(event: MouseEvent): unknown
  children?: ReactNode
  className?: string
  disabled?: boolean
  href?: string
  pad?: Padding
  path?: string
  primary?: boolean
  secondary?: boolean
  small?: boolean
  underline?: boolean
  wide?: boolean
  wrap?: boolean
}

export const Link = (all: Props) => {
  const { action, children, href, path, primary, secondary, small, underline, wide, wrap, ...props } = all

  const pad = getPaddingStyle(props.pad)
  const style = styles(pad)

  const link = href ?? path ?? ''
  const target = href ? '_blank' : undefined
  const rel = href ? 'noopener' : undefined
  const type = primary ? css.primary : secondary ? css.secondary : css.default
  const disabled = props.disabled || (!link && !action)

  const className = clsx(props.className, css.link, type, disabled && css.disabled,
    small && css.small, underline && css.underline, wide && css.wide, wrap && css.wrap)

  const onClick = useLatestCallback((event: MouseEvent) => {
    if (disabled) return

    const { metaKey, ctrlKey, altKey, shiftKey } = event
    const meta = Boolean(metaKey || ctrlKey || altKey || shiftKey)
    if (meta) return

    if (action) {
      event.preventDefault()
      action(event)
    } else if (path) {
      event.preventDefault()
      location.assign(path)
    }
  })

  return <a className={className} style={style} href={link} target={target} rel={rel} onClick={onClick}>
    {children}
  </a>
}
